import { type StoreActionApi } from 'react-sweet-state';

import type { ChatMessageResearchStore } from './types';

type SetHasThinkDeeperTriggeredArgs = { messageId: string; triggered: boolean };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const setHasThinkDeeperTriggered: (
	args: SetHasThinkDeeperTriggeredArgs,
) => ChatMessageResearchStoreAction =
	({ messageId, triggered }: { messageId: string; triggered: boolean }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const currentState = getState();
		const message = currentState[messageId];

		setState({
			[messageId]: {
				...(message ?? { steps: {}, researchPlans: {} }),
				hasThinkDeeperTriggered: triggered,
			},
		});
	};
